export default function (to, from, next) {
  next();
}